import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk,authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function commonAlert(text) {
  return {
    type: constants.COMMON_ALERT,
    text,
  };
}

export function commonCloseAlert() {
	return {
    type: constants.COMMON_CLOSE_ALERT,
  };
}

export function commonModalResize() {
	return {
    type: constants.COMMON_MODAL_RESIZE,
  };
}

export function adminSaveVendors(vendors) {
  return {
    type: constants.ADMIN_SAVE_VENDORS,
    vendors
  };
}

/******************************
*******  Asynchronous  ********
******************************/


export function commonUploadImage(giaNumber, file) {
  return dispatch => {
    let url = api.API_URL + endpoint.PROCESS_IMAGE_UPLOAD;
    
    let data = new FormData();
    data.append('file', file);
    data.append('gia_number', giaNumber);

    return fetch(url, {
      method: 'post',
      headers: authReq(api.FILE_HEADERS),
      body: data
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function commonUploadVideo(giaNumber, file) {
  return dispatch => {
    let url = api.API_URL + endpoint.PROCESS_VIDEO_UPLOAD;
    
    let data = new FormData();
    data.append('file', file);
    data.append('gia_number', giaNumber);

    return fetch(url, {
      method: 'post',
      headers: authReq(api.FILE_HEADERS),
      body: data
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function commonUploadCert(giaNumber, file) {
  return dispatch => {
    let url = api.API_URL + endpoint.PROCESS_CERT_UPLOAD;
    
    let data = new FormData();
    data.append('file', file);
    data.append('gia_number', giaNumber);

    return fetch(url, {
      method: 'post',
      headers: authReq(api.FILE_HEADERS),
      body: data
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function commonUploadPlot(giaNumber, file) {
  return dispatch => {
    let url = api.API_URL + endpoint.PROCESS_PLOT_UPLOAD;
    
    let data = new FormData();
    data.append('file', file);
    data.append('gia_number', giaNumber);

    return fetch(url, {
      method: 'post',
      headers: authReq(api.FILE_HEADERS),
      body: data
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function commonFetchGias() {
  return dispatch => {
    let url = api.API_URL + endpoint.PROCESS_FETCH_GIAS;
    return fetch(url, {
      method: 'get',
      headers: authReq(api.HEADERS),
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function commonFetchVendorGias(vendor) {
  return dispatch => {
    let url = api.API_URL + endpoint.PROCESS_FETCH_VENDOR_GIAS + '?vendor=' + vendor;
    return fetch(url, {
      method: 'get',
      headers: authReq(api.HEADERS),
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function commonUploadBulkCSV(file) {
  return dispatch => {
    let url = api.API_URL + endpoint.BULK_CSV_UPLOAD;
    
    let data = new FormData();
    data.append('file', file);

    return fetch(url, {
      method: 'post',
      headers: authReq(api.FILE_HEADERS),
      body: data
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function processFetchOverview() {
  return dispatch => {
    let url = api.API_URL + endpoint.PROCESS_FETCH_OVERVIEW;
    return fetch(url, {
      method: 'get',
      headers: authReq(api.FILE_HEADERS),
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}